<script>
import Flickity from 'vue-flickity'

export default {
    name: 'MessageContentCarousel',
    components: {
        Flickity
    },
    data () {
        return {
            flickityOptions: {
                initialIndex: 6,
                prevNextButtons: false,
                pageDots: false,
                freeScroll: true,
                contain: true,
                wrapAround: true
            }
        }
    },
    props: {
        content: {
            type: Object
        },
        time: {
            type: String
        }
    }
}
</script>

<template>
  <div class="wrapper">
    <Flickity ref="flickity" :options="flickityOptions">
      <div class="carousel-card" v-for="(card, idx) of this.content.carousel_cards" :key="idx">
        <img class="carousel-image" :src="card.image_url" alt="carousel_image"/>
        <div class="d-flex flex-column">
          <span class="carousel-title">{{ card.title }}</span>
          <span class="carousel-sub-title">{{ card.subtitle }}</span>
        </div>
        <button class="carousel-btn" v-for="(btn, idx) of card.buttons" :key="idx">
          {{ btn.title }}
        </button>
      </div>
    </Flickity>
    <span class="chat-time">{{ time | formatTimeHM }}</span>
  </div>
</template>

<style scoped lang="scss">
.chat-time {
  color: #7B7B7B;
  font-size: 12px;
  float: right;
}

.wrapper {
  width: 100%;

  .carousel-card {
    border-radius: 6px;
    padding: 10px;
    display: flex;
    background-color: #F1F6FE;
    margin-right: 12px;
    flex-direction: column;
    width: 66%;
    gap: 10px;

    .carousel-image {
      height: 180px;
      border-radius: 6px;
      object-fit: cover;
    }

    .carousel-title {
      font-weight: bold;
      color: #516C95;
    }

    .carousel-sub-title {
      color: #516C95;
    }

    .carousel-btn {
      padding: 10px;
      border-radius: 5px;
      background: #E0E9F6;
      font-weight: bold;
    }
  }
}
</style>
